
import { Component, Vue, Watch } from 'vue-property-decorator';
import { UserModule } from '@/store/modules/user';

import DoorItem from './components/systemDoorItem.vue';
import DoorItem2 from './components/systemDoorItem2.vue';
import DoorEdit from './components/systemDoorEdit.vue';
import { checkPermissionUseAndCompany } from '@/utils/permission';
import { Type } from '@/types/permissionType';
import { addServiceHomePage, getServiceHomePage, setOnlineToDraft } from '@/api/company';

@Component({
  name: 'Worktable',
  components: {
    DoorItem,
    DoorEdit,
    DoorItem2
  }
})

export default class extends Vue {
  // 获取的数据 统一 obj 数据格式为对象
  private componentsData: any = [{
    key: 'company_introduction',
    name: '公司介绍',
    show: true,
    src: require('@/assets/images/door-company.png'),
    obj: {
      control_show: {
        "logo_is_show": 1,
        "name_is_show": 1,
        "mobile_is_show": 1,
        "address_is_show": 1
      },
      "name": UserModule.getCompany.short_name,
      "mobile": UserModule.getCompany.mobile,
      "logo": UserModule.getCompany.logo_path,
      "logo_url": UserModule.getCompany.logo,
      "address": UserModule.getCompany.address
    }
  },
  {
    key: 'picture_ad',
    name: '图片广告',
    show: true,
    src: require('@/assets/images/door-advert.png'),
    obj: {
      list: []
    }
  },
  {
    key: 'company_notice',
    name: '公司公告',
    show: checkPermissionUseAndCompany(UserModule.getCompanyId, Type.CompanyNoticeInner),
    src: require('@/assets/images/door-announcement.png'),
    obj: {}
  },
  {
    key: 'picture_navigation',
    name: '图文导航',
    show: true,
    src: require('@/assets/images/door-nav.png'),
    obj: {
      list: [{
        icon: 'scan_report',
        title: '扫码报修',
        url: 'scan_report',
      }, {
        icon: 'order_list',
        title: '我的订单',
        url: 'order_list',
      }, {
        icon: 'report_order',
        title: '我要报修',
        url: 'report_order',
      }, {
        icon: 'service_hotline',
        title: '服务热线',
        url: 'service_hotline',
      }]
    }
  },
  {
    key: 'video_card',
    name: '视频广告',
    show: true,
    src: require('@/assets/images/door-video.png'),
    obj: {}
  },
  {
    key: 'title_text',
    name: '标题文本',
    show: true,
    src: require('@/assets/images/door-title.png'),
    obj: {}
  },
  {
    key: 'article_text',
    name: '富文本',
    show: true,
    src: require('@/assets/images/door-text.png'),
    obj: {}
  }]

  private dataArray: any = [];
  private dataArrayDialog:any=[];
  private selectDoor:any = {};

  created() {
    this.getServiceHomePage(5);
  }

  private clickHandle(val: any) {
    let arr = this.dataArray.filter((item:any) => {
      return item.key === val.key
    })
    if (!arr || arr.length < 1) {
      this.dataArray.push(val);
    }
    this.selectDoor = val;
  }
  private doorEditTypeHandle(val: any) {
    this.selectDoor = val;
  }
  private delDoorItem(index:any, item:any) {
    if (this.dataArray && this.dataArray.length > 0) {
      if (this.dataArray.length >= index) {
        this.selectDoor = this.dataArray[index]
      } else {
        this.selectDoor = this.dataArray[0]
      }
    } else {
      this.selectDoor = {}
    }

    this.componentsData.forEach((element:any) => {
      switch (element.key) {
        case 'company_introduction':
          if (item.key === 'company_introduction') {
            item.obj = {
              control_show: {
                "logo_is_show": 1,
                "name_is_show": 1,
                "mobile_is_show": 1,
                "address_is_show": 1
              },
              "name": UserModule.getCompany.name,
              "mobile": UserModule.getCompany.mobile,
              "logo": UserModule.getCompany.logo_path,
              "logo_url": UserModule.getCompany.logo,
              "address": UserModule.getCompany.address
            }
          }
          break
        case 'picture_ad':
          if (item.key === 'picture_ad') {
            item.obj = {
              list: []
            }
          }
          break
        case 'company_notice':
          if (item.key === 'company_notice') {
            item.obj = {}
          }
          break
        case 'picture_navigation':
          if (item.key === 'picture_navigation') {
            item.obj = {
              list: [{
                icon: 'scan_report',
                title: '扫码报修',
                url: 'scan_report',
              }, {
                icon: 'order_list',
                title: '我的订单',
                url: 'order_list',
              }, {
                icon: 'report_order',
                title: '我要报修',
                url: 'report_order',
              }, {
                icon: 'service_hotline',
                title: '服务热线',
                url: 'service_hotline',
              }]
            }
          }
          break
        case 'video_card':
          if (item.key === 'video_card') {
            item.obj = {}
          }
          break
        case 'title_text':
          if (item.key === 'title_text') {
            item.obj = {}
          }
          break
        case 'article_text':
          if (item.key === 'article_text') {
            item.obj = {}
          }
          break
      }
    })
  }
  // 发布
  private releaseHandle(type:any) {
    this.saveData(type)
  }
  private dialogPreviewVisible = false
  private previewHandle() {
    this.dataArrayDialog = [];
    this.dataArrayDialog = this.dataArray;
    this.dialogPreviewVisible = true;
  }
  private getServiceHomePage(type:number) {
    let params:any = {
      company_id: UserModule.getCompanyId,
      user_id: UserModule.getUserId,
      type: type
      // 草稿 1 已发布 3 最新一条 5
    };
    getServiceHomePage(params).then((res:any) => {
      if (res.data) {
        switch (type) {
          case 5:
            this.dataArray = this.dealData(res.data, 1);
            if (this.dataArray && this.dataArray.length > 0) {
              this.selectDoor = this.dataArray[0]
            }
            break
          case 3:
            this.dataArrayDialog = [];
            this.dataArrayDialog = this.dealData(res.data, 2);
            this.dialogPreviewVisible = true;
            break
        }
      } else {
        if (type === 3) {
          this.showErrorMsg('暂无已发布')
        }
      }
    })
  }
  private dealData(data:any, type:number) {
    let dataArray:any = [];
    let sortArray:any = data.sort.split(',');
    let aa = -1;
    if (type === 1) {
      let arr:any = [{
        key: 'company_introduction',
        name: '公司介绍',
        show: true,
        src: require('@/assets/images/door-company.png'),
        obj: {
          control_show: {
            "logo_is_show": 1,
            "name_is_show": 1,
            "mobile_is_show": 1,
            "address_is_show": 1
          },
          "name": UserModule.getCompany.name,
          "mobile": UserModule.getCompany.mobile,
          "logo": UserModule.getCompany.logo_path,
          "logo_url": UserModule.getCompany.logo,
          "address": UserModule.getCompany.address
        }
      },
      {
        key: 'picture_ad',
        name: '图片广告',
        show: true,
        src: require('@/assets/images/door-advert.png'),
        obj: {
          list: []
        }
      },
      {
        key: 'company_notice',
        name: '公司公告',
        show: checkPermissionUseAndCompany(UserModule.getCompanyId, Type.CompanyNoticeInner),
        src: require('@/assets/images/door-announcement.png'),
        obj: {}
      },
      {
        key: 'picture_navigation',
        name: '图文导航',
        show: true,
        src: require('@/assets/images/door-nav.png'),
        obj: {
          list: [{
            icon: 'scan_report',
            title: '扫码报修',
            url: 'scan_report',
          }, {
            icon: 'order_list',
            title: '我的订单',
            url: 'order_list',
          }, {
            icon: 'report_order',
            title: '我要报修',
            url: 'report_order',
          }, {
            icon: 'service_hotline',
            title: '服务热线',
            url: 'service_hotline',
          }]
        }
      },
      {
        key: 'video_card',
        name: '视频广告',
        show: true,
        src: require('@/assets/images/door-video.png'),
        obj: {}
      },
      {
        key: 'title_text',
        name: '标题文本',
        show: true,
        src: require('@/assets/images/door-title.png'),
        obj: {}
      },
      {
        key: 'article_text',
        name: '正文文本',
        show: true,
        src: require('@/assets/images/door-text.png'),
        obj: {}
      }]
      arr.forEach((element:any) => {
        switch (element.key) {
          case 'company_introduction':
            if (data.company_introduction) {
              element.obj = {
                'control_show': {
                  "logo_is_show": data.company_introduction.control_show.logo_is_show,
                  "name_is_show": data.company_introduction.control_show.name_is_show,
                  "mobile_is_show": data.company_introduction.control_show.mobile_is_show,
                  "address_is_show": data.company_introduction.control_show.address_is_show
                },
                "name": data.company_introduction.name,
                "mobile": data.company_introduction.mobile,
                "logo": data.company_introduction.logo,
                "logo_url": data.company_introduction.logo_url,
                "address": data.company_introduction.address
              }
              let aa = -1;
              sortArray.filter((sor:any, index:number) => {
                if (sor === 'company_introduction') {
                  aa = index
                }
              })
              if (aa !== -1) {
                dataArray[aa] = element
              }
            }
            break
          case 'picture_ad':
            if (data.picture_ad) {
              element.obj = {
                list: data.picture_ad
              }
              let aa = -1;
              sortArray.filter((sor:any, index:number) => {
                if (sor === 'picture_ad') {
                  aa = index
                }
              })
              if (aa !== -1) {
                dataArray[aa] = element
              }
            }
            break
          case 'company_notice':
            element.obj = data.company_notice
            element.show = checkPermissionUseAndCompany(UserModule.getCompanyId, Type.CompanyNoticeInner)

            sortArray.filter((sor:any, index:number) => {
              if (sor === 'company_notice') {
                aa = index
              }
            })
            if (aa !== -1) {
              dataArray[aa] = element
            }
            break
          case 'picture_navigation':
            if (data.picture_navigation) {
              element.obj = {
                list: data.picture_navigation
              }
              let aa = -1;
              sortArray.filter((sor:any, index:number) => {
                if (sor === 'picture_navigation') {
                  aa = index
                }
              })
              if (aa !== -1) {
                dataArray[aa] = element
              }
            }
            break
          case 'video_card':
            if (data.video_card) {
              element.obj = data.video_card
              let aa = -1;
              sortArray.filter((sor:any, index:number) => {
                if (sor === 'video_card') {
                  aa = index
                }
              })
              if (aa !== -1) {
                dataArray[aa] = element
              }
            }
            break
          case 'title_text':
            if (data.title_text) {
              element.obj = data.title_text
              let aa = -1;
              sortArray.filter((sor:any, index:number) => {
                if (sor === 'title_text') {
                  aa = index
                }
              })
              if (aa !== -1) {
                dataArray[aa] = element
              }
            }
            break
          case 'article_text':
            if (data.article_text) {
              element.obj = {
                article_text: data.article_text
              }
              let aa = -1;
              sortArray.filter((sor:any, index:number) => {
                if (sor === 'article_text') {
                  aa = index
                }
              })
              if (aa !== -1) {
                dataArray[aa] = element
              }
            }
            break
        }
      });
    } else {
      this.componentsData.forEach((element:any) => {
        switch (element.key) {
          case 'company_introduction':
            if (data.company_introduction) {
              element.obj = {
                'control_show': {
                  "logo_is_show": data.company_introduction.control_show.logo_is_show,
                  "name_is_show": data.company_introduction.control_show.name_is_show,
                  "mobile_is_show": data.company_introduction.control_show.mobile_is_show,
                  "address_is_show": data.company_introduction.control_show.address_is_show
                },
                "name": data.company_introduction.name,
                "mobile": data.company_introduction.mobile,
                "logo": data.company_introduction.logo,
                "logo_url": data.company_introduction.logo_url,
                "address": data.company_introduction.address
              }
              let aa = -1;
              sortArray.filter((sor:any, index:number) => {
                if (sor === 'company_introduction') {
                  aa = index
                }
              })
              if (aa !== -1) {
                dataArray[aa] = element
              }
            }
            break
          case 'picture_ad':
            if (data.picture_ad) {
              element.obj = {
                list: data.picture_ad
              }
              let aa = -1;
              sortArray.filter((sor:any, index:number) => {
                if (sor === 'picture_ad') {
                  aa = index
                }
              })
              if (aa !== -1) {
                dataArray[aa] = element
              }
            }
            break
          case 'company_notice':
            element.obj = data.company_notice
            element.show = checkPermissionUseAndCompany(UserModule.getCompanyId, Type.CompanyNoticeInner)

            sortArray.filter((sor:any, index:number) => {
              if (sor === 'company_notice') {
                aa = index
              }
            })
            if (aa !== -1) {
              dataArray[aa] = element
            }
            break
          case 'picture_navigation':
            if (data.picture_navigation) {
              element.obj = {
                list: data.picture_navigation
              }
              let aa = -1;
              sortArray.filter((sor:any, index:number) => {
                if (sor === 'picture_navigation') {
                  aa = index
                }
              })
              if (aa !== -1) {
                dataArray[aa] = element
              }
            }
            break
          case 'video_card':
            if (data.video_card) {
              element.obj = data.video_card
              let aa = -1;
              sortArray.filter((sor:any, index:number) => {
                if (sor === 'video_card') {
                  aa = index
                }
              })
              if (aa !== -1) {
                dataArray[aa] = element
              }
            }
            break
          case 'title_text':
            if (data.title_text) {
              element.obj = data.title_text
              let aa = -1;
              sortArray.filter((sor:any, index:number) => {
                if (sor === 'title_text') {
                  aa = index
                }
              })
              if (aa !== -1) {
                dataArray[aa] = element
              }
            }
            break
          case 'article_text':
            if (data.article_text) {
              element.obj = {
                article_text: data.article_text
              }
              let aa = -1;
              sortArray.filter((sor:any, index:number) => {
                if (sor === 'article_text') {
                  aa = index
                }
              })
              if (aa !== -1) {
                dataArray[aa] = element
              }
            }
            break
        }
      });
    }
    return dataArray
  }
  private saveData(type:any) {
    let params:any = {
      company_id: UserModule.getCompanyId,
      user_id: UserModule.getUserId,
      type: type
    };
    let msgList: any = []
    if (!this.dataArray || this.dataArray.length < 1) {
      this.showErrorMsg('从左侧选择一个组件吧～')
      return
    }
    this.dataArray.forEach((item:any) => {
      if (!params.sort) {
        if (item.show) {
          params.sort = item.key + ','
        }
      } else {
        if (item.show) {
          params.sort = params.sort + item.key + ","
        }
      }
      switch (item.key) {
        case 'company_introduction':
          params.company_introduction = JSON.stringify(item.obj)
          break
        case 'picture_ad':
          if (item.obj.list && item.obj.list.length > 0) {
            item.obj.list.forEach((element:any, index:number) => {
              if (!element.img) {
                msgList.push('图片广告，图片' + (index + 1) + '请上传图片')
              }
              // if (!element.url) {
              //   msgList.push('图片广告，图片' + (index + 1) + '请填写跳转链接')
              // }
            });
          }
          params.picture_ad = JSON.stringify(item.obj.list)
          break
        case 'company_notice':
          //20230828 只要有就为1 数据从数据库取
          if (item.show) {
            // if (!item.obj.id) {
            //   msgList.push('公司公告，请选择公司公告')
            // }
            params.company_notice = JSON.stringify({is_have:1})
          }

          break
        case 'picture_navigation':
          if (item.obj.list && item.obj.list.length > 0) {
            item.obj.list.forEach((element:any) => {
              if (!element.title) {
                let msg = ''
                switch (element.url) {
                  case 'scan_report':
                    msg = '扫码报修';
                    break;
                  case 'order_list':
                    msg = '我的订单';
                    break;
                  case 'report_order':
                    msg = '我要报修';
                    break;
                  case 'unconfirmed_order':
                    msg = '待验收订单';
                    break;
                  case 'unevaluated_order':
                    msg = '待评价订单';
                    break;
                  case 'service_hotline':
                    msg = '服务热线';
                    break;
                  case 'device_list':
                    msg = '我的设备';
                    break;
                  case 'company_notice':
                    msg = '公司公告';
                    break;
                }
                msgList.push('图文导航,请填写' + msg + '的标题')
              }
              if (!element.url) {
                msgList.push('图文导航,请选择链接')
              }
            });
          }
          params.picture_navigation = JSON.stringify(item.obj.list)
          break
        case 'video_card':
          if (!item.obj.img) {
            msgList.push('视频广告，请上传图片')
          }
          if (!item.obj.url) {
            msgList.push('视频广告，请填写跳转链接')
          }
          params.video_card = JSON.stringify(item.obj)
          break
        case 'title_text':
          if (!item.obj.title) {
            msgList.push('标题文本，请填写标题名称')
          }
          // if (!item.obj.subtitle_title) {
          //   msgList.push('标题文本，请填写标题名称')
          // }
          params.title_text = JSON.stringify(item.obj)
          break
        case 'article_text':
          if (!item.obj.article_text) {
            msgList.push('正文文本，请填写正文文本')
          }
          params.article_text = item.obj.article_text
          break
      }
    })
    if (msgList && msgList.length > 0) {
      this.showErrorMsg(msgList[0])
      // msgList.forEach((msg:any) => {
      //   this.showErrorMsg(msg)
      // })
      return
    }
    addServiceHomePage(params).then((res:any) => {
      this.showSuccessMsg(res.msg)
      this.getServiceHomePage(5)
    }).catch(err => {
      this.showErrorMsg(err.msg)
    })
  }
  private backRelease() {
    let params:any = {
      company_id: UserModule.getCompanyId,
      user_id: UserModule.getUserId,
    };
    setOnlineToDraft(params).then((res:any) => {
      this.showSuccessMsg(res.msg)
      if (res.data) {
        this.dataArray = this.dealData(res.data, 1);
        if (this.dataArray && this.dataArray.length > 0) {
          this.selectDoor = this.dataArray[0]
        }
      }
    }).catch(err => {
      this.showErrorMsg(err.msg)
    })
  }
  private lookRelease() {
    this.getServiceHomePage(3)
  }
  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSuccessMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'success'
    });
  }
}

